import { useState } from "react";
import { Alert, Badge, Button, Col, Container, FloatingLabel, Form, InputGroup, Modal, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { MdCheck, MdClose, MdOutlineTipsAndUpdates } from "react-icons/md";
import { createMachineAsync } from "./api";


export default function MachineCreate({ jwt, onHide, show, onCreated }) {
    const [machineName, setMachineName] = useState('');
    const [machineDescription, setMachineDescription] = useState('');
    const [isLive, setIsLive] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [machineCategoryId, setMachineCategoryId] = useState(0);
    const categoriesAll = [
        { id: 1, name: 'Лазерные станки' },
        { id: 2, name: 'УФ-станки' },
        { id: 3, name: 'Литейные станки' },
    ];

    const onSubmit = async (e) => {
        e.preventDefault();

        if (machineName == null || machineName == '') {
            alert('Введите имя');
            return;
        }

        if (machineCategoryId == 0) {
            alert('Некорректная категория');
            return;
        }

        try {
            const machineResponse = await createMachineAsync({
                name: machineName,
                description: machineDescription,
                isLive: isLive,
                categoryId: machineCategoryId
            }, jwt);

            if (!machineResponse) {
                alert('Ошибка при создании станка');
                return;
            }
            alert(`Создан станок "${machineResponse.name}" с id ${machineResponse.id}`)
            onCreated({
                name: machineResponse.name, id: machineResponse.id, description: machineDescription, isLive: isLive,
                categoryId: machineCategoryId
            });
            onHide();

        } catch (error) {
            console.error('Ошибка при создании станка:', error);
            alert('Произошла ошибка при создании станка');
        }
    }

    return <Modal show={show}
        onHide={onHide}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered>
        <Form onSubmit={onSubmit}>
            <Modal.Header closeButton>
                <Modal.Title>
                    <span>Создание нового станка</span>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container>
                    <Row>
                        <h5>Имя</h5>
                        <InputGroup className="mb-3">
                            <Form.Control
                                type='text'
                                onChange={e => setMachineName(e.target.value)}
                            />
                        </InputGroup>
                    </Row>
                    <Row>
                        <h5>Описание</h5>
                        <InputGroup className="mb-3">
                            <Form.Control
                                type='text'
                                onChange={e => setMachineDescription(e.target.value)}
                            />
                        </InputGroup>
                    </Row>
                    <Row>
                        <h5>Категория</h5>
                        <Form.Select
                            value={selectedCategory?.id || ""}
                            onChange={(e) => {
                                const selectedId = e.target.value;
                                const selectedCategory = categoriesAll.find(c => c.id === (selectedId ? Number(selectedId) : null));
                                setSelectedCategory(selectedCategory || null);
                                setMachineCategoryId(selectedId);
                            }}
                            style={{ maxWidth: 300 }}
                        >
                            <option value="">Выберите категорию</option>
                            {categoriesAll.map(category => (
                                <option key={category.id} value={category.id}>
                                    {category.name}
                                </option>
                            ))}
                        </Form.Select>
                    </Row>
                </Container>
            </Modal.Body>
            <Modal.Footer>
                <Form.Check
                    type="switch"
                    className="me-auto"
                    checked={isLive}
                    onChange={e => setIsLive(e.target.checked)}
                    label={'Станок активен'} />
                <Button variant="secondary" onClick={onHide}>Закрыть</Button>
                <Button variant="success" type="submit">Сохранить</Button>
            </Modal.Footer>
        </Form>
    </Modal>
}